"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaginationLoadMoreButtonVisibility = void 0;
const getPaginationLoadMoreButtonVisibility = (countOfLoadedArticles, countOfArticles) => countOfArticles === undefined ? false : countOfLoadedArticles < countOfArticles;
exports.getPaginationLoadMoreButtonVisibility = getPaginationLoadMoreButtonVisibility;
